import React from 'react';

import style from './join.module.scss';

export const Join = () => {
    return (
        <div className={style.join}>
            <div className={style.joinItem}>
                <img
                    alt=""
                    className={style.joinImage}
                    src={process.env.PUBLIC_URL + '/assets/image/about/join.png'}
                ></img>
            </div>

            <div className={style.joinItem}>
                <div className={style.joinContent}>
                    <div className={style.joinTitle}>Join Our Team</div>
                    <div className={style.joinText}>
                        At Wintech Rubber & Plastics, we offer career opportunities that are as unique and
                        high-performing as the materials we custom-formulate every day. If you're looking for an
                        opportunity where you can make a difference for businesses and their customers worldwide,
                        explore our open positions here.
                    </div>
                </div>
            </div>
        </div>
    );
};
